/**
 * view redux actions
 * 
 * @author    Jens Gruschel, Maurizio Tidei
 * @copyright © 2018 contexagon GmbH
 */


import {
    CLOSE_MEDIA_OVERLAY, OPEN_MEDIA_OVERLAY, OPEN_PAGE, UPDATE_VIEW_PROPERTY
} from "./consts";


export const openPageAction = (pageId) => ({
    type: OPEN_PAGE,
    page: pageId
});

export const openMediaOverlayAction = (url, description) => ({
    type: OPEN_MEDIA_OVERLAY,
    url: url,
    description: description
});

export const closeMediaOverlayAction = () => ({
    type: CLOSE_MEDIA_OVERLAY
});

export const updateViewProperty = (section, name, value) => ({
    type: UPDATE_VIEW_PROPERTY,
    section: section,
    name: name,
    value: value
});